export const headerSearchBarStyles = {
	root: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		width: '100%',
		justifySelf: 'center'
	},

	searchRoot: {
		borderRadius: '999px',
		height: '40px',
		backgroundColor: 'rgba(255, 255, 255, 0.8)'
	},

	inputField: {
		fontSize: '1.125rem',
		lineHeight: 1.5,
		fontWeight: 400,
		fontFamily: 'inherit',

		'& .MuiInputBase-input': {
			'::placeholder': {
				color: 'text.secondary',
				opacity: 1
			},
			color: 'text.secondary'
		}
	},

	searchIcon: {
		color: 'text.secondary',
		'& svg': {
			fontSize: 24
		}
	},

	dropdown: {
		'@media (min-height: 900px)': {
			maxHeight: '100vh'
		}
	}
};
